import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
   selector: 'app-email-template-send',
   templateUrl: './email-template-send.component.html',
   styleUrls: ['./email-template-send.component.css']
})
export class EmailTemplateSendComponent {
   form: FormGroup;

   submitted = false;

   title: string = '';

   languageSuffix: string = '';

   language: string = '';

   constructor(
      @Inject(MAT_DIALOG_DATA)
      public data: { title: string; languageSuffix: string; language: string } | null = { title: '', languageSuffix: '', language: '' },
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<EmailTemplateSendComponent>
   ) {
      this.form = this.fb.group({
         comment: ['']
      });
      this.title = data?.title || '';
      this.languageSuffix = data?.languageSuffix || '';
      this.language = data?.language || '';
   }

   onSubmit(): void {
      this.submitted = true;
      if (this.form.invalid) {
         this.form.markAllAsTouched();
         return;
      }
      this.dialogRef.close(this.form.value);
   }
}
